import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Notification } from '../../services/requests/notifications';

export type NotificationState = {
  notifications: Notification[];
  selectedNotification: Partial<Notification> | null;
  setSelectedNotification: (notification: Notification) => void;
  setNotifications: (notifications: Notification[]) => void;
  countNotification: number | null;
  setCountNotification: (type: number) => void;
};

const useNotificationStore = create(
  persist<NotificationState>(
    set =>
      ({
        notifications: [],
        selectedNotification: null,
        countNotification: null,
        setCountNotification: (type: number) =>
          set({
            countNotification: type,
          }),
        setSelectedNotification: (notification: Notification) =>
          set({
            selectedNotification: notification,
          }),

        setNotifications: (notifications: Notification[]) =>
          set({
            notifications,
          }),
      } as unknown as NotificationState),
    {
      name: '@tenGovUseNotificationStore',
    },
  ),
);
export default useNotificationStore;
